import { useState, useEffect, Fragment } from 'react'
import { startUseCredit } from '../../utils/creditSystem';

function RewriteModal({ onClose, onRewrite, isLoading }) {
    const [selectedStyle, setSelectedStyle] = useState('');
    const [customPrompt, setCustomPrompt] = useState('');
    const [error, setError] = useState('');
    try {

        const styles = [
            { id: 'laogao', name: '老高風格', description: '神秘、驚奇、探索未知的敘事風格' },
            { id: 'mrbeast', name: 'Mr. Beast風格', description: '吸引人、誇張、充滿驚喜的表達方式' },
            { id: 'xiaohongshu', name: '小紅書風格', description: '親近、生活化、實用的分享體驗' },
            { id: 'custom', name: '自定義風格', description: '自行輸入想要的風格描述' }
        ];

        const handleSubmit = async (e) => {
            e.preventDefault();
            
            if (!selectedStyle) {
                setError('請選擇一種重寫風格');
                return;
            }
            
            if (selectedStyle === 'custom' && !customPrompt.trim()) {
                setError('請輸入自定義風格描述');
                return;
            }
            
            try {
                // Then proceed with rewriting
                onRewrite(selectedStyle, customPrompt);
            } catch (err) {
                setError(err.message || '重寫失敗，請稍後再試');
            }
        };

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-name="rewrite-modal">
                <div className="bg-white rounded-xl w-full max-w-md shadow-2xl" data-name="modal-content">
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-2xl font-bold">
                                選擇重寫風格
                            </h2>
                            <button 
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600 transition-colors"
                                disabled={isLoading}
                                data-name="close-button"
                            >
                                <i className="fas fa-times text-xl"></i>
                            </button>
                        </div>

                        {error && (
                            <div 
                                className="bg-red-50 border-l-4 border-red-400 p-4 mb-4 rounded"
                                role="alert"
                                data-name="error-message"
                            >
                                <div className="flex">
                                    <i className="fas fa-exclamation-circle text-red-400 mr-3"></i>
                                    <p className="text-red-700">{error}</p>
                                </div>
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="space-y-3 mb-6">
                                {styles.map(style => (
                                    <div 
                                        key={style.id}
                                        onClick={() => setSelectedStyle(style.id)}
                                        className={`border rounded-lg p-4 cursor-pointer transition-colors ${
                                            selectedStyle === style.id 
                                                ? 'border-indigo-500 bg-indigo-50' 
                                                : 'border-gray-200 hover:border-gray-300'
                                        }`}
                                        data-name={`style-option-${style.id}`}
                                    >
                                        <div className="flex items-center mb-2">
                                            <input
                                                type="radio"
                                                name="style"
                                                value={style.id}
                                                checked={selectedStyle === style.id}
                                                onChange={() => setSelectedStyle(style.id)}
                                                className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                            />
                                            <label className="ml-3 font-medium">
                                                {style.name}
                                            </label>
                                        </div>
                                        <p className="text-sm text-gray-600 ml-7">
                                            {style.description}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            {selectedStyle === 'custom' && (
                                <div className="mb-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        自定義風格描述
                                    </label>
                                    <textarea
                                        value={customPrompt}
                                        onChange={(e) => setCustomPrompt(e.target.value)}
                                        placeholder="請描述您想要的寫作風格..."
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500"
                                        rows="4"
                                        data-name="custom-prompt-input"
                                    ></textarea>
                                </div>
                            )}
                            
                            <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                                <div className="flex items-center">
                                    <i className="fas fa-coins text-yellow-500 mr-2"></i>
                                    <p className="text-yellow-700">此操作將消耗 1 點數</p>
                                </div>
                            </div>

                            <div className="flex justify-end space-x-4">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                    disabled={isLoading}
                                    data-name="cancel-button"
                                >
                                    取消
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors flex items-center"
                                    disabled={isLoading}
                                    data-name="submit-button"
                                >
                                    {isLoading ? (
                                        <Fragment>
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                            處理中...
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <i className="fas fa-magic mr-2"></i>
                                            開始重寫
                                        </Fragment>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        console.error('RewriteModal component error:', error);
        reportError(error);
        return null;
    }
}

export default RewriteModal;